<template>
  <div
    class="form-group"
    :class="{
      'input-group-focus': focused,
      'has-danger': error,
      'has-success': hasSuccess,
      'has-label': label,
      'has-icon': hasIcon,
    }"
  >
    <slot name="label">
      <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
    </slot>
    <div class="mb-0" :class="{'input-group': hasIcon}">
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" id="addon-left" class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon"></i></div>
        </span>
      </slot>
      <slot>
        <textarea
          v-if="isMultiline"
          :value="valueFiltered"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          :maxlength="maxLength"
          :aria-describedby="describedby"
          :style="{ 'background-color': responsesBackColor }"
          title="Input Multi-line Text"
        ></textarea>
        <input
          v-else
          :value="valueFiltered"
          v-bind="$attrs"
          v-on="listeners"
          class="form-control"
          :aria-describedby="describedby"
          :style="{ 'background-color': responsesBackColor, 'text-align': textAlign, 'font-size': fontSize, 'font-weight': fontWeight }"
          :readonly="readonly"
          title="Input Text"
        />
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" id="addon-right" class="input-group-append">
          <div class="input-group-text"><i :class="addonRightIcon"></i></div>
        </span>
      </slot>
    </div>

    <slot name="error" v-if="error || $slots.error">
      <h6 class="text-danger">{{ error }}</h6>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'base-input',
  props: {
    required: Boolean,
    label: {
      type: String,
      description: 'Input label'
    },
    error: {
      type: String,
      description: 'Input error',
      default: ''
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right'
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left'
    },
    isMultiline: {
      type: Boolean,
      default: false
    },
    hspResponseId: {
      type: Number,
      default: -1
    },
    maxLength: {},
    responsesBackColor: String,
    readonly: Boolean,
    textAlign: String,
    fontSize: String,
    fontWeight: String,
    hideValue: Boolean,
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      focused: false,
      touched: false
    };
  },
  computed: {
    hasIcon() {
      return this.hasLeftAddon || this.hasRightAddon
    },
    hasLeftAddon() {
      const { addonLeft } = this.$slots;
      return (
        addonLeft !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
    hasRightAddon() {
      const { addonRight } = this.$slots;
      return (
        addonRight !== undefined ||
        this.addonRightIcon !== undefined
      );
    },
    describedby() {
      if (!this.hasIcon) {
        return null;
      }

      return this.hasLeftAddon && this.hasRightAddon ? "addon-right addon-left"
        : this.hasLeftAddon ? "addon-left"
        : "addon-right";
    },
    hasSuccess() {
      let valLength = this.value ? this.value.trim().length : 0;

      return !this.error && valLength > 0;
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus
      };
    },
    valueFiltered() {
      if (!this.hideValue) {
        return this.value;
      }

      return '';
    }
  },
  methods: {
    onInput(evt) {
      if (!this.touched) {
        this.touched = true;
      }
      this.$emit('input', evt.target.value, this.hspResponseId);
    },
    onFocus(evt) {
      this.focused = true;
      this.$emit('focus', evt)
    },
    onBlur(evt) {
      this.focused = false;
      this.$emit('blur', evt)
    }
  }
};
</script>
<style scoped="true">
textarea.form-control {
  border: 1px solid rgba(29, 37, 59, 0.5);
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
}
textarea.form-control:focus, textarea.form-control:active {
  border: 1px solid #e14eca;
}
</style>
